import React from 'react';
import { Box, Card, Container, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

import visa from '../../../../assets/payment-logos/visa.svg';
import amex from '../../../../assets/payment-logos/american-express.svg';
import master from '../../../../assets/payment-logos/mastercard.svg';
import bancolombia from '../../../../assets/payment-logos/boton-bancolombia.svg';
import cash from '../../../../assets/payment-logos/cash.svg';
import nequi from '../../../../assets/payment-logos/nequi.svg';
import pse from '../../../../assets/payment-logos/pse.svg';
import qrCodeButton from '../../../../assets/payment-logos/qr-code-button.svg';

import {
	logoBoxSx,
	logoGridSx,
	paymentCardSx,
	paymentIntroSx,
	paymentNoteSx,
	paymentSectionTitleSx,
} from './sharedStyles';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			flexGrow: 1,
			paddingTop: theme.spacing(2),
			maxWidth: '100%',
		},
	}),
);

const paymentLogos = [
	{ logo: visa, alt: 'visa' },
	{ logo: amex, alt: 'american-express' },
	{ logo: master, alt: 'master-card' },
	{ logo: nequi, alt: 'nequi' },
	{ logo: bancolombia, alt: 'Bancolombia' },
	{ logo: cash, alt: 'pago-en-efectivo' },
	{ logo: pse, alt: 'pse' },
	{ logo: qrCodeButton, alt: 'codigo-qr' },
];

interface MevueloCOPaymentMethodsProps {
	isExternal?: boolean;
}

const MevueloCOPaymentMethods = ({ isExternal }: MevueloCOPaymentMethodsProps): JSX.Element => {
	const classes = useStyles();
	return (
		<div className={classes.root}>
			<Container component="main" maxWidth="md">
				<Typography component="h1" variant="h6" sx={paymentSectionTitleSx(isExternal)}>
					Nuestras formas de pago:
				</Typography>
				<Typography variant="body2" color="text.secondary" fontWeight={500} sx={paymentIntroSx}>
					Elegí la forma de pago que mejor se adapte a tu viaje.
				</Typography>
				<Card sx={paymentCardSx}>
					<Typography variant="body2" fontWeight={800} color="primary">
						Medios disponibles
					</Typography>
					<Box sx={logoGridSx}>
						{paymentLogos.map((item) => (
							<Box key={item.alt} sx={logoBoxSx}>
								<img src={item.logo} alt={item.alt} width={80} />
							</Box>
						))}
					</Box>
					<Typography sx={paymentNoteSx} variant="body2" align="center" color="text.secondary" fontWeight={700}>
						Tarjetas de crédito de otros bancos en un solo pago sin interés o en cuotas con recargo. Consultá con tu
						banco.
					</Typography>
				</Card>
			</Container>
		</div>
	);
};
export default MevueloCOPaymentMethods;
